import { render, staticRenderFns } from "./wait-loader.vue?vue&type=template&id=56b48c17&scoped=true&"
import script from "./wait-loader.vue?vue&type=script&lang=js&"
export * from "./wait-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b48c17",
  null
  
)

export default component.exports